import { render, staticRenderFns } from "./BanListProfile.vue?vue&type=template&id=d1afecc8&scoped=true&"
import script from "./BanListProfile.vue?vue&type=script&lang=js&"
export * from "./BanListProfile.vue?vue&type=script&lang=js&"
import style0 from "./BanListProfile.vue?vue&type=style&index=0&id=d1afecc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1afecc8",
  null
  
)

export default component.exports